import { select } from 'redux-saga/effects';
import { createSelector } from 'reselect';
import { getIsPrescriptionStepValid, getPrescriptionType } from '../../selectors.js';
import { PrescriptionUploadStepContainer } from '../../../../Configurator/steps/PrescriptionUploadStep/PrescriptionUploadStepContainer.js';

const prescriptionUploadStepBase = {
    *onNext () {
        const isValid = yield select(getIsPrescriptionStepValid);
        if (!isValid) {
            return new Error(`Need valid prescription data for unknown customer`);
        }
    },
    view: PrescriptionUploadStepContainer,
    stepStatus: createSelector(getPrescriptionType, (prescriptionType)=>prescriptionType === 'PrescriptionFile' ? 'sub-step' : 'hidden'
    )
};

export { prescriptionUploadStepBase };
//# sourceMappingURL=prescription-upload.js.map
